import clsx from 'clsx';
import { AmenityItem, AmenityLabel, IconWrapper, AmenitySRLabel } from './Amenity.styles';
import { AmenityProps } from './Amenity.types';
import { parseIconClass } from './utils';

export function Amenity({ className, iconClass, label }: AmenityProps) {
  const splitLabel = () => {
    const trimmedLabel = label?.trim().split(/\s+/);
    const lastWord = trimmedLabel?.pop();
    return [trimmedLabel?.join(' '), lastWord];
  };
  const [firstLine, secondLine] = splitLabel();
  return (
    <AmenityItem className={className} role="listitem">
      {/* icon is decorative; hide from SR since the label conveys meaning */}
      <IconWrapper aria-hidden="true">
        <span className={clsx('icon', parseIconClass(iconClass))} />
      </IconWrapper>
      {label ? (
        <div className="d-flex flex-column">
          {/* sr-only full label so split rendering doesn't confuse SR */}
          <AmenitySRLabel className="sr-only">{label}</AmenitySRLabel>
          <AmenityLabel aria-hidden="true" className="t-font-alt-xs fw-bold">
            {firstLine}
          </AmenityLabel>
          <AmenityLabel aria-hidden="true" className="t-font-alt-xs fw-bold">
            {secondLine}
          </AmenityLabel>
        </div>
      ) : null}
    </AmenityItem>
  );
}
